import { render, staticRenderFns } from "./Airplane.vue?vue&type=template&id=771b2edc"
import script from "./Airplane.vue?vue&type=script&lang=js"
export * from "./Airplane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports